export const appName = "INFINITIBOT";
export const appTagline = "STEM • Robotics • Coding • AI";
export const heroBadge = "Future Skills for Young Minds";
export const phoneDisplay = "+91 7318140223";
/** Digits only, country code without + — for tel: and WhatsApp links */
export const phoneE164 = "917318140223";
export const email = "info.infinitibotrobotics@gmail.com";
export const whatsappUrl = `https://wa.me/${phoneE164}`;
export const gradesRange = "Classes 1–12";
export const mailtoHref = `mailto:${email}`;
export const telHref = `tel:+${phoneE164}`;
